import {m} from 'framer-motion';
import {useTranslation} from 'react-i18next';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import {SeverErrorIllustration} from 'src/assets/illustrations';

import {varBounce, MotionContainer} from 'src/minimal-components/animate';

// ----------------------------------------------------------------------

interface ErrorFoundProps {
  error: any;
  handleReset: (error: any) => void;
}

export default function ErrorFound({error, handleReset}: ErrorFoundProps) {
  const {t} = useTranslation();

  return (
    <MotionContainer>
      <m.div variants={varBounce().in}>
        <Typography variant="h3" sx={{mb: 2}}>
          {t('An error has occurred!')}
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <Typography sx={{color: 'text.secondary'}}>
          {t('We are sorry for the inconvenience. Our team has been notified.')}
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <SeverErrorIllustration sx={{height: 260, my: {xs: 5, sm: 10}}} />
      </m.div>

      <Button
        onClick={() => handleReset(error)}
        size="large"
        variant="contained">
        {t('Try Again')}
      </Button>
    </MotionContainer>
  );
}
